import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-rangeslider/lib/index.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormik } from "formik";
import * as Yup from "yup";


  
import axios from "axios";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

const EcommerceAddProduct = () => {
  document.title = "SMS | Kuryesen Admin Paneli";

  const dispatch = useDispatch();

  const [getContactEdit, setContactEdit] = useState(null);

  const [getUsers, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: '',
      mailAdress:''
        },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen Başlık Giriniz")
    }),
    onSubmit: (values) => {

      selectedUsers.map((item, index) => {

        const newUser = {
          title: values.title,
          body: values.desc,
          USERID:item,
          icerikTuru:"kullanici"
        }
  
        axios.post('https://getjob.stechomeyazilim.info:5101/pushnotificationKupon1/send', newUser).then(response => {
      
      })
    
         showToast(true)
        console.log("şlscmdflş",res.data)
      })


      //dispatch(onUpdateAbout(updateOrder));
      validation.resetForm();

    },
  });


  const handleSelectChangeUsers = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setSelectedUsers(selectedOptions); // Seçilen değerleri durum olarak güncelleyin
  }

  function showToast(type) {
    console.log("type123",type)
    let ele = null
    let message = "";
  
     if(type == true){
       ele = "success"
       message = "Başarıyla Sms Gönderilmiştir"
    } else{
       ele = "error"
       message = getFalseDesc
    };
    const position = ["toast-top-right"];
    let toastType;
    const title = "Başlık";
  
  
    //Close Button
    const closeButton = true;
  
    //Debug
    const debug = false;
  
    //Progressbar
    const progressBar = true;
  
    //Duplicates
    const preventDuplicates = false;
  
    //Newest on Top
    const newestOnTop = true;
  
    //position class
    let positionClass = "toast-top-right";
  
    //Show Easing
    const showEasing = "swing";
  
    //Hide Easing
    const hideEasing = "linear";
  
    //show method
    const showMethod = "fadeIn";
  
    //Hide method
    const hideMethod = "fadeOut";
  
    //show duration
    const showDuration = 300;
  
    //Hide duration
    const hideDuration = 1000;
  
    //timeout
    const timeOut = 5000;
  
    //extended timeout
    const extendedTimeOut = 1000;
  
    //Fetch checked Type
   
     toastType = ele;
    
  
    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      debug: debug,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showEasing: showEasing,
      hideEasing: hideEasing,
      showMethod: showMethod,
      hideMethod: hideMethod,
      showDuration: showDuration,
      hideDuration: hideDuration
    };
  
    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  }
  const { users } = useSelector(state => ({
    users: state.contacts.about,
  }));

  const _getUsers= async () => {

    await axios.get(`https://buharaapi.stechomeyazilim.info/Users/`)
      .then((res) => {
        setUsers(res.data.value || res.data)
      })
  }

  useEffect(() => {
    _getUsers()
  }, [getUsers]);



  useEffect(() => {
    if (!isEmpty(users)) {
      setContactEdit(users[0]);
    }
  }, [users]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="SMS" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>SMS</CardTitle>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>

                      <div className="mb-3">
                        <Label htmlFor="productname">Başlık</Label>
                        <Input
                          id="title"
                          name="title"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.title || ""}
                          invalid={
                            validation.touched.title && validation.errors.title ? true : false
                          }
                        />
                        {validation.touched.title && validation.errors.title ? (
                          <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                        ) : null}

                      </div>
                      

                      <div className="mb-3">
                        <Label htmlFor="productname">Açıklama</Label>
                        <Input
                          id="desc"
                          name="desc"
                          type="text"
                          className="form-control"
                          placeholder="Başlık"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.desc || ""}
                          invalid={
                            validation.touched.desc && validation.errors.desc ? true : false
                          }
                        />
                        {validation.touched.desc && validation.errors.desc ? (
                          <FormFeedback type="invalid">{validation.errors.desc}</FormFeedback>
                        ) : null}

                      </div>
                   
                      <div className="mb-3">
                        <Label htmlFor="productname">Mail Adresi</Label>
                        <Input
                          id="mailAdress"
                          name="mailAdress"
                          type="text"
                          className="form-control"
                          placeholder="Mail Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.mailAdress || ""}
                          invalid={
                            validation.touched.mailAdress && validation.errors.mailAdress ? true : false
                          }
                        />
                        {validation.touched.mailAdress && validation.errors.mailAdress ? (
                          <FormFeedback type="invalid">{validation.errors.mailAdress}</FormFeedback>
                        ) : null}

                      </div>
                      

                      <div className="mb-3">
                        <Label className="form-label">Kullanıcı Seçiniz</Label>
                        <Input
                          name="group"
                          type="select"
                          className="form-select"
                          multiple
                          value={selectedUsers} // Burada selectedValues, bileşenin seçili değerlerini içeren bir durumdur
                          onChange={(event) => handleSelectChangeUsers(event)}
                        >
                          {getUsers.map((item, index) => (
                            <option value={item.ID} key={item.ID}>{item.NameSurname}</option>
                          ))}

                        </Input>
                       
                      </div>


                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Kaydet
                      </Button>
                      <Button type="submit" color="secondary" className=" ">
                        İptal
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>


            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EcommerceAddProduct
